import { STORAGE_ROLE_NAME } from '@/config/display/storage.config'
import { AUTH_MR, AUTH_DM, AUTH_ADMIN } from '@/config/display/auth.config'
import { _hasOwn } from '@/utils/common.util'
// 根据不同权限，限定操作
// const mr = {
//   inserted: (el, binding) => {
//     // 获取用户职位名
//     const userRoleName = localStorage.getItem(STORAGE_ROLE_NAME)
//     // 职位不匹配或者不是双职位，则禁止操作
//     if (userRoleName !== AUTH_MR && userRoleName !== AUTH_ADMIN) {
//       el.disabled = 'disabled'
//       el.className += ' public-no-action'
//     }
//   },
// }
// const dm = {
//   inserted: (el, binding) => {
//     // 获取用户职位名
//     const userRoleName = localStorage.getItem(STORAGE_ROLE_NAME)
//     // 职位不匹配或者不是双职位，则禁止操作
//     if (userRoleName !== AUTH_DM && userRoleName !== AUTH_ADMIN) {
//       el.disabled = 'disabled'
//       el.className += ' public-no-action'
//     }
//   },
// }

// 指令示例
// v-auth.mr="69" 这个操作权限需要mr，这个用户的权限是69经理,不符合，不给权限
// v-auth.dm="70" 这个操作权限需要dm，这个用户的权限是70代表兼经理,符合，给权限
// v-auth.remake="69" 这个操作权限需要mr或者代表兼经理，这个用户的权限是69经理,不符合，隐藏重拍按钮
// 70代表兼经理同时有这两种权限
const auth = {
  inserted: (el, binding) => {
    // 需要的权限
    const authObject = binding.modifiers
    // 用户的权限
    const userAuthNum = binding.value

    if (
      // 需要代表权限
      _hasOwn(authObject, 'mr') &&
      // 用户是代表或是代表兼经理
      (+userAuthNum === AUTH_MR || +userAuthNum === AUTH_ADMIN)
    ) {
      // pass
    } else if (
      // 需要经理权限
      _hasOwn(authObject, 'dm') &&
      // 用户是经理或是代表兼经理
      (+userAuthNum === AUTH_DM || +userAuthNum === AUTH_ADMIN)
    ) {
      // pass
    } else if (
      // 是否具有重拍权限
      _hasOwn(authObject, 'remake')
    ) {
      // 用户不是代表或代表兼经理
      if (+userAuthNum !== AUTH_MR && +userAuthNum !== AUTH_ADMIN) {
        el.className += ' not-show'
      }
    } else {
      // 不符合上述条件，则不可操作
      el.disabled = 'disabled'
      el.className += ' public-no-action'
    }
  },
}

export default { auth }
